import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export default function DropTimer({ dropAt, label = "FULL RELEASE", compact = false }) {
  const target = new Date(dropAt);
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const when = target.toLocaleDateString(undefined, { month: "long", day: "numeric" }).toUpperCase();
  const time = target.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" }).toUpperCase();
  const diff = target - now;

  if (compact) {
    if (diff <= 0) return null;
    return (
      <p data-testid="drop-timer-compact" className="mt-1.5 font-mono text-[9px] tracking-[0.2em] text-bone/60">
        DROPS {when}, {time} — {Math.floor(diff / 86400000)}D {pad(Math.floor((diff % 86400000) / 3600000))}H {pad(Math.floor((diff % 3600000) / 60000))}M {pad(Math.floor((diff % 60000) / 1000))}S
      </p>
    );
  }

  if (diff <= 0) {
    return (
      <div data-testid="drop-timer" className="mt-6 border border-bone/30 bg-bone/5 p-5">
        <p className="font-mono text-[10px] tracking-[0.3em] text-bone">LIVE NOW — RIGHT PLACE. RIGHT TIME.</p>
      </div>
    );
  }

  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff % 86400000) / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);

  return (
    <div data-testid="drop-timer" className="mt-6 border border-white/15 bg-coal/60 p-5">
      <p className="font-mono text-[9px] tracking-[0.3em] text-fade">
        {label} — {when}, {time}
      </p>
      <div className="mt-3 flex gap-2">
        {[
          [d, "DAYS"],
          [h, "HRS"],
          [m, "MIN"],
          [s, "SEC"],
        ].map(([v, l]) => (
          <div key={l} className="flex-1 border border-white/10 py-2.5 text-center">
            <p className="font-mono text-xl font-bold tabular-nums text-bone">{pad(v)}</p>
            <p className="mt-0.5 font-mono text-[8px] tracking-[0.3em] text-fade">{l}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
